export default __webpack_public_path__ + "static/media/bookmark2.de004df4.png";